// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__y9TVE","notes":"Notes_notes__2TbNW","note":"Notes_note__vOkLx","markdown":"Notes_markdown__2YMdS"};